export interface DetailedSummaryResponseProps {
  category: string
  totalValue: number
  percentageValue: number
}

export const detailedSummaryMock: DetailedSummaryResponseProps[] = [
  {
    category: 'CD Horti fruti',
    totalValue: 140470.98,
    percentageValue: 92.07
  },
  {
    category: 'CD Refrigerante',
    totalValue: 1671.6,
    percentageValue: 0.31
  },
  {
    category: 'CD Secos',
    totalValue: 5590.75,
    percentageValue: 5.94
  },
  {
    category: 'CD Descartáveis',
    totalValue: 2855.92,
    percentageValue: 1.87
  },
  {
    category: 'CD Produto de Limpeza',
    totalValue: 0,
    percentageValue: 1.87
  },
  {
    category: 'CD Produto de Higiene',
    totalValue: 0,
    percentageValue: 92.07
  },
  {
    category: 'CD Carnes',
    totalValue: 0,
    percentageValue: 0.31
  },
  {
    category: 'CD Grãos',
    totalValue: 0,
    percentageValue: 5.94
  },
  {
    category: 'CD Lanches',
    totalValue: 0,
    percentageValue: 1.87
  },
  {
    category: 'CD Diversos',
    totalValue: 0,
    percentageValue: 1.87
  }
]
